import qs from 'query-string';

export const UTM_SOURCE_GREET_SHARE_PAGE = 'share_page';
export const UTM_SOURCE_TESTIMONIAL_REQUEST_PAGE = 'testimonials_request_page';
export const UTM_SOURCE_TESTIMONIAL_WALL_OF_LOVE = 'testimonials_wall_of_love';

export const UTM_MEDIUM_POWERED_BY_BADGE = 'powered_by_badge';
export const UTM_MEDIUM_THANK_YOU_BANNER = 'thank_you_banner';
export const UTM_MEDIUM_HEADER_BADGE = 'header_badge';

export const UTM_CAMPAIGN_TESTIMONIALS_PLG = 'testimonials_plg';
export const UTM_CAMPAIGN_GREET_REFERRALS = 'greet_referrals';

export interface UtmDetails {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export const addUtmToLink = (link: string, utmDetails: UtmDetails) => {
  return `${link}?${qs.stringify(utmDetails)}`;
};
